import { Directive,}  from '@angular/core';
import { ACTION_MODE } from '../common.enum';
import { ActivatedRoute, Router, UrlSegment, } from '@angular/router';
import { AccountsService } from '../../services/account.service';

@Directive()
export abstract class BaseEntityComponent {
  isLoading=false;
  addFlag = false; editFlag = false; deleteFlag = false; viewFlag=false; showContent= false;
  backColor?:string|null='';
  foreColor?:string|null='';
  urlLastSegment?:string|null='';
  ACTION_MODE= ACTION_MODE;
  mode: ACTION_MODE =ACTION_MODE.NONE;
  id!:number;
  currentRole?:string|null =null;
  selectedAppID?:number|null =null;;


  constructor(
    protected route: ActivatedRoute,
    protected accountService: AccountsService
  ) {
    this.backColor= this.accountService.getBackColor();
    this.foreColor= this.accountService.getForeColor();
  }

  ngOnInit(): void {
    this.currentRole= this.accountService.getRoleName();
    const segments: UrlSegment[] = this.route.snapshot.url;
    if (segments.length > 0) {
      this.urlLastSegment = segments[segments.length - 1].path;
    }
    this.route.params.subscribe(params => {
      this.id = params['id'] as number;
      console.log('Route Parameter [id]: ', this.id);
    });
    this.selectedAppID= this.accountService.getAppId();
  }
  hasPermission(code:string):boolean{
    return this.accountService.hasPermission(code);
  }
  resetAppColors(){
    this.backColor= this.accountService.getBackColor();
    this.foreColor= this.accountService.getForeColor();
  }

}
